export enum scope {
  add = 'add',
  edit = 'edit',
}

export interface FieldType {
  field: string
  headerName: string
  shortHeaderName?: string
  hide?: boolean
  input?:
    | 'text'
    | 'select'
    | 'tableSelect'
    | 'date'
    | 'upload'
    | 'checkbox'
    | 'alphanumeric'
    | 'multiline'
    | 'integer'
    | 'float'
    | 'formula'
    | 'multichip'
  hidden?: scope[] //excludes from showing in modal
  disabled?: boolean | scope[]
  required?: boolean
  readonly?: boolean
}

export const attributeColsMod: FieldType[] = [
  {
    field: 'AttrID',
    headerName: 'ID',
    hidden: [scope.add],
    disabled: true,
    input: 'integer',
    readonly: true,
  },
  {
    field: 'AttrDatatype',
    headerName: 'Datatype',
    input: 'select',
    disabled: [scope.edit],
    readonly: true,
  },
  {
    field: 'AttrName',
    headerName: 'Name',
    hidden: [scope.add],
  },
  {
    field: 'AttrCodeSetID',
    headerName: 'Codeset ID',
    hidden: [scope.add],
    disabled: true,
  },
  {
    field: 'options',
    headerName: 'Options',
    hidden: [scope.add],
    input: 'multichip',
  },
  {
    field: 'EndpointText',
    headerName: 'Endpoint Text',
    hidden: [scope.add],
  },
  {
    field: 'Formula',
    headerName: 'Formula',
    hidden: [scope.add],
    input: 'formula',
  },
  {
    field: 'PhaseID',
    headerName: 'Phase ID',
    hidden: [scope.add, scope.edit],
    disabled: true,
    readonly: true,
  },
  {
    field: 'SeqNo',
    headerName: 'Sequence',
    hidden: [scope.add, scope.edit],
    input: 'integer',
  },
  {
    field: 'StudyID',
    headerName: 'Study ID',
    hidden: [scope.add, scope.edit],
    disabled: true,
    readonly: true,
  },
]
